<template>
    <v-form ref="form" v-model="valid">
        <v-container class="room">
            <v-btn v-if="roomIndex !== 1"
                   depressed
                   color="error"
                   @click="$emit('removeRoom', {roomIndex, id: hotelRoom !== null ? hotelRoom.id : null})"
            >
                Excluir Esse Quarto
            </v-btn>
            <v-row class="mt-4">
                <v-col cols="12" md="4">
                    <v-text-field
                        outlined
                        v-model="name"
                        :rules="nameRules"
                        label="Nome do Quarto"
                        :error-messages="roomNameErrors"
                        @blur="validateRoomName"
                        required
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field
                        outlined
                        v-model="description"
                        label="Descrição"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-select
                        :items="[1,2,3]"
                        label="Número de Hóspedes no Quarto"
                        v-model="guests"
                        :rules="guestsRules"
                        outlined
                    ></v-select>
                </v-col>
            </v-row>

            <v-tabs v-model="activeTab" class="mb-5">
                <v-tab>Tarifas Padrão</v-tab>
                <v-tab>Tarifas Sazonais</v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab">
                <v-tab-item>
                    <v-btn
                        depressed
                        color="primary"
                        type="button"
                        @click="addFare"
                        class="mb-3"
                    >
                        Adicionar Tarifa para esse Quarto
                    </v-btn>
                    <fare
                        v-on:removeFare="removeFare"
                        v-on:fare-state-changed="onFareStateChanged"
                        v-for="fare in fares"
                        :fareIndex="fare.key"
                        ref="fares" :key="fare.key"
                        :room-fare="standardFareByKey(fare.key)"
                        :disabled-days="getDisabledDaysForFare(fare.key)"
                    />
                </v-tab-item>

                <v-tab-item eager>
                    <v-btn
                        depressed
                        color="primary"
                        type="button"
                        @click="addSeasonalFare"
                        class="mb-3"
                    >
                        Adicionar Tarifa Sazonal
                    </v-btn>
                    <fare
                        v-on:removeFare="removeSeasonalFare"
                        v-on:fare-state-changed="onSeasonalFareStateChanged"
                        v-for="fare in faresSeasonal"
                        :fareIndex="fare.key"
                        ref="faresSeasonal" :key="fare.key"
                        :room-fare="seasonalFareByKey(fare.key)"
                        :disabled-days="[]"
                        :is-seasonal="true"
                        :host-room-id="hotelRoom ? hotelRoom.id : null"
                    />
                </v-tab-item>
            </v-tabs-items>
        </v-container>
    </v-form>
</template>

<script>
import Fare from "./Fare.vue";

export default {
    name: "Room",
    components: {
        Fare
    },
    props: {
        roomIndex: {
            type: Number
        },
        hotelRoom: {
            type: Object
        }
    },
    data: () => ({
        valid: false,
        name: '',
        description: '',
        guests: '',
        deleted: false,
        fares: [{
            key: 1
        }],
        faresSeasonal: [],
        fareStates: {},
        fareStatesSeasonal: {},
        activeTab: 0,
        hotelRoomStandardFares: [],
        hotelRoomSeasonalFares: [],
        nameRules: [
            v => !!v || 'O nome do quarto é obrigatorio'
        ],
        guestsRules: [
            v => !!v || 'O número de hóspedes é obrigatorio'
        ],
        roomNameErrors: [],
    }),
    methods: {
        getData() {
            const standardFaresData = this.$refs.fares
                ? this.$refs.fares.map(function (fare) { return fare.getData(); })
                : [];
            const seasonalFaresData = this.$refs.faresSeasonal
                ? this.$refs.faresSeasonal.map(function (fare) { return fare.getData(); })
                : [];

            const data = {
                "name": this.name,
                "description": this.description,
                "guests": this.guests,
                "fares": standardFaresData.concat(seasonalFaresData),
            };

            if (this.hotelRoom !== null) {
                data.id = this.hotelRoom.id;
            }

            return data;
        },
        setData() {
            this.name = this.hotelRoom.name;
            this.description = this.hotelRoom.description;
            this.guests = this.hotelRoom.guests;

            const standardFares = [];
            const seasonalFares = [];

            this.hotelRoom.fares.forEach(function (fare) {
                const hasSeasonality =
                    fare.rules &&
                    fare.rules.applicability &&
                    fare.rules.applicability.seasonality_rules &&
                    fare.rules.applicability.seasonality_rules.length > 0;

                if (hasSeasonality) {
                    seasonalFares.push(fare);
                } else {
                    standardFares.push(fare);
                }
            });

            this.hotelRoomStandardFares = standardFares;
            this.hotelRoomSeasonalFares = seasonalFares;

            this.fares = standardFares.map(function (_, i) { return { key: i + 1 }; });
            if (this.fares.length === 0) {
                this.fares = [{ key: 1 }];
                this.hotelRoomStandardFares = [null];
            }

            this.faresSeasonal = seasonalFares.map(function (_, i) { return { key: i + 1 }; });
        },
        standardFareByKey: function (key) {
            const fare = this.hotelRoomStandardFares[key - 1];
            return fare !== undefined ? fare : null;
        },
        seasonalFareByKey: function (key) {
            const fare = this.hotelRoomSeasonalFares[key - 1];
            return fare !== undefined ? fare : null;
        },
        addFare() {
            const lastKey = this.fares.length > 0 ? this.fares[this.fares.length - 1].key : 0;
            this.fares.push({
                key: lastKey + 1
            });
        },
        removeFare(key) {
            const indexOf = this.fares.findIndex(function (fare) {
                return fare.key === key;
            });
            this.fares.splice(indexOf, 1);
            this.$delete(this.fareStates, key);
        },
        addSeasonalFare: function () {
            const maxKey = this.faresSeasonal.reduce(function (max, f) { return Math.max(max, f.key); }, 0);
            this.faresSeasonal.push({ key: maxKey + 1 });
        },
        removeSeasonalFare: function (key) {
            const indexOf = this.faresSeasonal.findIndex(function (fare) {
                return fare.key === key;
            });
            this.faresSeasonal.splice(indexOf, 1);
            this.$delete(this.fareStatesSeasonal, key);
        },
        onSeasonalFareStateChanged: function (payload) {
            this.$set(this.fareStatesSeasonal, payload.fareKey, {
                weekDays: payload.weekDays,
                breakfast: payload.breakfast,
                hasAgreement: payload.hasAgreement,
            });
        },
        validate() {
            const formsValidated = this.$refs.form.validate();

            const standardFaresValid = this.$refs.fares
                ? this.$refs.fares.every(function (fare) { return fare.hasSelectedAtLeastOneWeekDay; })
                : true;

            const seasonalFaresValid = this.$refs.faresSeasonal
                ? this.$refs.faresSeasonal.every(function (fare) {
                    const periodsValid = fare.validateSeasonality();
                    return fare.hasSelectedAtLeastOneWeekDay && periodsValid;
                  })
                : true;

            this.valid = formsValidated && standardFaresValid && seasonalFaresValid;
        },
        onFareStateChanged(payload) {
            this.$set(this.fareStates, payload.fareKey, {
                weekDays: payload.weekDays,
                breakfast: payload.breakfast,
                hasAgreement: payload.hasAgreement
            });
        },
        getDisabledDaysForFare(fareKey) {
            return this.disabledDaysByFare[fareKey] || [];
        },
        hasSameBreakfastType(fareA, fareB) {
            return !!fareA.breakfast === !!fareB.breakfast;
        },
        getSiblingFares(fareKey) {
            var currentFare = this.fareStates[fareKey];
            var self = this;
            return Object.keys(this.fareStates)
                .filter(function (key) { return key !== String(fareKey); })
                .map(function (key) { return self.fareStates[key]; })
                .filter(function (fare) { return !fare.hasAgreement && self.hasSameBreakfastType(fare, currentFare); });
        },
        collectClaimedDays(fares) {
            var days = [];
            fares.forEach(function (fare) {
                fare.weekDays.forEach(function (day) {
                    if (days.indexOf(day) === -1) {
                        days.push(day);
                    }
                });
            });
            return days;
        },
        async validateRoomName() {
            if (!this.name) {
                return;
            }

            this.hotelNameErrors = [];

            const response = await axios.get(`/api/restricted-names/check/?string=${encodeURIComponent(this.name)}`);
            if (response && response.data && response.data.success === true) {
                this.roomNameErrors = [];
            } else {
                this.roomNameErrors = [response.data.message];
            }

            this.$nextTick(() => {
                const input = this.$refs.form.inputs.find(function (input) { return input.$attrs.label === 'Nome do Quarto'; });
                if (input) { input.validate(); }
            });
        },
    },
    computed: {
        disabledDaysByFare() {
            var result = {};
            var self = this;
            Object.keys(this.fareStates).forEach(function (key) {
                result[key] = self.collectClaimedDays(self.getSiblingFares(key));
            });
            return result;
        }
    },
    created() {
        if (this.hotelRoom !== null) {
            this.setData();
        }
    }
}
</script>

<style scoped>
.room {
    border: 1px solid rgba(0, 0, 0, .38);
    border-radius: 8px;
    margin-bottom: 2rem;
    padding: 16px;
}
</style>
